import { cx } from '~/ui/cx.js';

/**
 * The leaning capsule the Classic hint and review hang on a choice: BEST in
 * lemon on the one the ranking put first, YOURS in white on the player's own.
 *
 * The Cross review's board tag (`cellTagClass` in `ui/GridBoard.tsx`), which
 * `classic-hint` and `classic-review-play` reuse: the ink stroke, the stamp
 * shadow and the lean. It is one drawing in two placements, so Best on a card
 * and Best in the dock's list read as the same mark (Mitch, 2026-09-18).
 *
 * `inline` stands in a line of text, the dock ledger's placement. `pinned`
 * hangs off the top-right corner of its positioned parent, the placement a
 * card or a cell wears. `pinned-start` is the same off the top-left corner,
 * for a second tag that must not collide with a pinned one: Change plan's
 * Current beside the Bundle's Most popular (Mitch, 2026-09-21). The lean
 * stays the same, so the two read as one mark. The label is the caller's copy.
 *
 * Graduated from `dev/sketches/cross-chrome.tsx`'s `BoardTag`.
 */
export function LeanTag({
  label,
  lemon = false,
  small = false,
  placement,
}: {
  readonly label: string;
  /** The recommended choice. White otherwise. */
  readonly lemon?: boolean;
  /** The phone's size. */
  readonly small?: boolean;
  readonly placement: 'inline' | 'pinned' | 'pinned-start';
}): React.JSX.Element {
  return (
    <span
      className={cx(
        'rounded-full border-2 border-ink text-xs font-extrabold tracking-widest whitespace-nowrap uppercase shadow-sm shadow-stamp',
        lemon ? 'bg-lemon' : 'bg-ground-light',
        // A span, so it may stand inside a button; the placement sets its display.
        placement === 'inline'
          ? 'inline-block'
          : cx(
              'absolute z-1 block',
              small ? '-top-2' : '-top-2.5',
              placement === 'pinned'
                ? small
                  ? '-right-3'
                  : '-right-4'
                : small
                  ? '-left-3'
                  : '-left-4',
            ),
        'rotate-6',
        small ? 'px-2 py-px' : 'px-2 py-0.5',
      )}
    >
      {label}
    </span>
  );
}
